// // import styled from 'styled-components';
// // import { animated } from 'react-spring';

// // const Main = styled.div`
// //   flex: 1;
// //   display: flex;
// //   height: 100%;
// //   max-height: calc(100vh - 75px);

// //   h2 {
// //     font-size: 28px;
// //     font-weight: bold;
// //     color: #2c405a;
// //     margin-bottom: 20px;
// //   }
// // `;

// // Main.Container = styled.div`
// //   flex: 1;
// //   display: flex;
// //   flex-direction: column;
// //   box-shadow: inset 0 0 1em #00000026;
// //   padding: 40px 5px 20px 20px;
// //   background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
// //   height: 100%;
// // `;

// // Main.Wrapper = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   flex: 1;
// //   padding: 20px;
// //   overflow-y: auto;
// // `;

// // Main.Section = styled.div`
// //   display: flex;
// //   flex-wrap: wrap;
// //   justify-content: center;
// // `;

// // Main.Footer = styled.footer`
// //   display: flex;
// //   justify-content: flex-end;
// //   padding: 10px;
// //   background: none;

// //   > a {
// //     > img {
// //       width: 150px;
// //       opacity: 0.9;
// //     }
// //   }
// // `;

// // const Card = styled(animated.div)`
// //   display: flex;
// //   position: relative;
// //   background: #fff;
// //   box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
// //   border-radius: 15px;
// //   margin: 15px;
// //   height: 100%;
// //   height: 300px;
// //   width: 100%;
// //   max-width: 290px;
// //   transition: transform 0.3s ease, box-shadow 0.3s ease;

// //   &:hover {
// //     transform: scale(1.05);
// //     box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
// //   }

// //   > a {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     font-size: 14px;
// //     color: inherit;
// //     text-decoration: none;
// //     text-align: center;
// //     height: 100%;
// //     width: 100%;
// //     /* border: 1px solid #e5e7eb; */
// //     border-radius: 10px;
// //     padding: 20px;
// //   }
// // `;

// // Card.Wrapper = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   align-items: center;
// //   text-align: center;
// // `;

// // Card.Language = styled.div`
// //   position: absolute;
// //   top: 0;
// //   right: 0;
// //   padding: 5px;
// //   color: #2c405a;
// //   /* border: 1px solid #2c405a; */
// //   border-radius: 5px;
// //   font-size: 10px;
// // `;

// // Card.Title = styled.h4`
// //   margin: 10px 0;
// //   color: #2c405a;
// // `;

// // Card.Image = styled.img`
// //   border-radius: 10px;
// //   /* width: 100%; */
// //   max-width: 200px;
// //   max-height: 200px;
// //   /* height: 100%; */
// //   /* object-fit: cover; */
// //   /* box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1); */
// // `;

// // Card.Content = styled.span`
// //   color: #555;
// //   font-size: 14px;
// //   margin: 5px 0;
// // `;

// // Card.Maintenance = styled.div`
// //   position: absolute;
// //   background: rgba(0, 0, 0, 0.4);
// //   top: 0;
// //   left: 0;
// //   right: 0;
// //   bottom: 0;
// //   border-radius: 10px;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   cursor: not-allowed;
// // `;

// // Card.Maintenance.Content = styled.span`
// //   display: flex;
// //   align-items: center;
// //   gap: 10px;
// //   background-color: rgba(255, 255, 255, 0.92);
// //   color: #de3b3b;
// //   padding: 10px 20px;
// //   border-radius: 5px;
// //   max-width: 95%;

// //   > span {
// //     text-align: center;
// //   }
// // `;

// // export { Main, Card };

// import styled from 'styled-components';
// import { animated } from 'react-spring';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --primary: #ff6d3c   --ink: #17263b / #2c405a   --muted: #64748b
//    --border: rgba(216, 224, 235, 0.9)
// =========================================================== */

// const Main = styled.div`
//   flex: 1;
//   display: flex;
//   height: 100%;
//   max-height: calc(100vh - 75px);

//   h2 {
//     font-size: 28px;
//     font-weight: 800;
//     letter-spacing: -0.6px;
//     color: #17263b;
//     margin-bottom: 20px;
//   }
// `;

// Main.Container = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   height: 100%;
//   padding: 40px 5px 20px 20px;
//   box-shadow: inset 0 0 1em #0000001a;
//   background: linear-gradient(135deg, #f7f9fc 0%, #eef2f8 100%);
// `;

// Main.Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   padding: 20px;
//   overflow-y: auto;
// `;

// Main.Section = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// Main.Footer = styled.footer`
//   display: flex;
//   justify-content: flex-end;
//   padding: 10px;
//   background: none;

//   > a {
//     > img {
//       width: 150px;
//       opacity: 0.9;
//       transition: opacity 0.2s ease;

//       :hover {
//         opacity: 1;
//       }
//     }
//   }
// `;

// const Card = styled(animated.div)`
//   display: flex;
//   position: relative;
//   height: 300px;
//   width: 100%;
//   max-width: 290px;
//   margin: 15px;

//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 18px;
//   box-shadow: 0 10px 26px rgba(23, 38, 59, 0.1);
//   transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
//     box-shadow 0.3s ease, border-color 0.3s ease;

//   &:hover {
//     transform: translateY(-6px);
//     border-color: rgba(255, 109, 60, 0.35);
//     box-shadow: 0 22px 44px rgba(23, 38, 59, 0.18);
//   }

//   > a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 100%;
//     width: 100%;
//     padding: 22px;
//     border-radius: 18px;
//     text-align: center;
//     text-decoration: none;
//     font-size: 14px;
//     color: inherit;
//   }
// `;

// Card.Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
// `;

// Card.Language = styled.div`
//   position: absolute;
//   top: 10px;
//   right: 10px;
//   padding: 4px 10px;
//   border-radius: 999px;
//   background: rgba(255, 109, 60, 0.12);
//   color: #d4572a;
//   font-size: 10px;
//   font-weight: 800;
//   letter-spacing: 0.4px;
//   text-transform: uppercase;
// `;

// Card.Title = styled.h4`
//   margin: 12px 0 4px;
//   color: #17263b;
//   font-size: 16px;
//   font-weight: 800;
//   letter-spacing: -0.2px;
// `;

// Card.Image = styled.img`
//   border-radius: 12px;
//   max-width: 200px;
//   max-height: 200px;
// `;

// Card.Content = styled.span`
//   margin: 5px 0;
//   color: #64748b;
//   font-size: 14px;
// `;

// Card.Maintenance = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 18px;
//   background: rgba(6, 14, 26, 0.45);
//   backdrop-filter: blur(1px);
//   cursor: not-allowed;
// `;

// Card.Maintenance.Content = styled.span`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   max-width: 95%;
//   padding: 12px 20px;
//   border-radius: 12px;
//   background-color: rgba(255, 255, 255, 0.95);
//   color: #de3b3b;
//   font-weight: 700;
//   box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);

//   > span {
//     text-align: center;
//   }
// `;

// export { Main, Card };

// import styled from 'styled-components';
// import { animated } from 'react-spring';

// const Main = styled.div`
//   flex: 1;
//   display: flex;
//   height: 100%;
//   max-height: calc(100vh - 75px);

//   h2 {
//     font-size: 28px;
//     font-weight: bold;
//     color: #2c405a;
//     margin-bottom: 20px;
//   }
// `;

// Main.Container = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   box-shadow: inset 0 0 1em #00000026;
//   padding: 40px 5px 20px 20px;
//   background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
//   height: 100%;
// `;

// Main.Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   padding: 20px;
//   overflow-y: auto;
// `;

// Main.Section = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// Main.Footer = styled.footer`
//   display: flex;
//   justify-content: flex-end;
//   padding: 10px;
//   background: none;

//   > a {
//     > img {
//       width: 150px;
//       opacity: 0.9;
//     }
//   }
// `;

// const Card = styled(animated.div)`
//   display: flex;
//   position: relative;
//   background: #fff;
//   box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
//   border-radius: 15px;
//   margin: 15px;
//   height: 100%;
//   height: 300px;
//   width: 100%;
//   max-width: 290px;
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     transform: scale(1.05);
//     box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
//   }

//   > a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 14px;
//     color: inherit;
//     text-decoration: none;
//     text-align: center;
//     height: 100%;
//     width: 100%;
//     /* border: 1px solid #e5e7eb; */
//     border-radius: 10px;
//     padding: 20px;
//   }
// `;

// Card.Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
// `;

// Card.Language = styled.div`
//   position: absolute;
//   top: 0;
//   right: 0;
//   padding: 5px;
//   color: #2c405a;
//   /* border: 1px solid #2c405a; */
//   border-radius: 5px;
//   font-size: 10px;
// `;

// Card.Title = styled.h4`
//   margin: 10px 0;
//   color: #2c405a;
// `;

// Card.Image = styled.img`
//   border-radius: 10px;
//   /* width: 100%; */
//   max-width: 200px;
//   max-height: 200px;
//   /* height: 100%; */
//   /* object-fit: cover; */
//   /* box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1); */
// `;

// Card.Content = styled.span`
//   color: #555;
//   font-size: 14px;
//   margin: 5px 0;
// `;

// Card.Maintenance = styled.div`
//   position: absolute;
//   background: rgba(0, 0, 0, 0.4);
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   border-radius: 10px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: not-allowed;
// `;

// Card.Maintenance.Content = styled.span`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   background-color: rgba(255, 255, 255, 0.92);
//   color: #de3b3b;
//   padding: 10px 20px;
//   border-radius: 5px;
//   max-width: 95%;

//   > span {
//     text-align: center;
//   }
// `;

// export { Main, Card };

import styled from 'styled-components';
import { animated } from 'react-spring';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --ink: #17263b / #2c405a   --muted: #64748b
   --border: rgba(216, 224, 235, 0.9)
=========================================================== */

const Main = styled.div`
  flex: 1;
  display: flex;
  height: 100%;

  /** acompanha a altura do header definida em styles/global.js */
  max-height: calc(100vh - var(--app-header-h));

  h2 {
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.6px;
    color: #17263b;
    margin-bottom: 20px;
  }

  @media (max-width: 1440px), (max-height: 900px) {
    h2 {
      font-size: 22px;
      margin-bottom: 12px;
    }
  }
`;

Main.Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  padding: 40px 5px 20px 20px;
  box-shadow: inset 0 0 1em #0000001a;
  background: linear-gradient(135deg, #f7f9fc 0%, #eef2f8 100%);

  @media (max-width: 1440px), (max-height: 900px) {
    padding: 16px 6px 8px 16px;
  }
`;

Main.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 20px;
  overflow-y: auto;

  @media (max-width: 1440px), (max-height: 900px) {
    padding: 10px 14px;
  }
`;

Main.Section = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

Main.Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: none;

  > a {
    > img {
      width: 150px;
      opacity: 0.9;
      transition: opacity 0.2s ease;

      :hover {
        opacity: 1;
      }
    }
  }
`;

const Card = styled(animated.div)`
  display: flex;
  position: relative;
  height: 300px;
  width: 100%;
  max-width: 290px;
  margin: 15px;

  /** cartões mais compactos em tablet: mais catálogos visíveis por tela */
  @media (max-width: 1440px), (max-height: 900px) {
    height: 252px;
    max-width: 232px;
    margin: 10px;
  }

  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 18px;
  box-shadow: 0 10px 26px rgba(23, 38, 59, 0.1);
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(255, 109, 60, 0.35);
    box-shadow: 0 22px 44px rgba(23, 38, 59, 0.18);
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 22px;
    border-radius: 18px;
    text-align: center;
    text-decoration: none;
    font-size: 14px;
    color: inherit;
  }
`;

Card.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

Card.Language = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 109, 60, 0.12);
  color: #d4572a;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

Card.Title = styled.h4`
  margin: 12px 0 4px;
  color: #17263b;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.2px;
`;

Card.Image = styled.img`
  border-radius: 12px;
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;

  @media (max-width: 1440px), (max-height: 900px) {
    max-width: 152px;
    max-height: 152px;
  }
`;

Card.Content = styled.span`
  margin: 5px 0;
  color: #64748b;
  font-size: 14px;
`;

Card.Maintenance = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: rgba(6, 14, 26, 0.45);
  backdrop-filter: blur(1px);
  cursor: not-allowed;
`;

Card.Maintenance.Content = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 95%;
  padding: 12px 20px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.95);
  color: #de3b3b;
  font-weight: 700;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);

  > span {
    text-align: center;
  }
`;

export { Main, Card };
